/**
 * Цветовая схема компонента относительно родительского контейнера.
 */
enum ColorSchema {
    /**
     * Тёмные компоненты на светлом фоне.
     */
    DARK = 'dark',

    /**
     * Светлые компоненты на тёмном фоне
     */
    LIGHT = 'light',
}

export default ColorSchema;
